import React from "react";
import { Row, Col } from "antd";
import "./Banner.css";
import { Link } from "react-router-dom";

const BannerUpgrade = ({ image, color, imgWidth, isAbsolute }) => {
  return (
    <section
      className="bannerContainer"
      style={{ textAlign: "center", backgroundColor: color }}
    >
      <Row className="rowContainer">
        <Col
          xl={12}
          ml={12}
          xs={24}
          sm={24}
          className="bannerLeftSectionContainer"
        >
          <div className="bannerTitle">Aller plus loin.</div>
          <div className="bannerDescription">
            <p>
              Testez gratuitement toutes les fonctionnalités PREMIUM et boostez
              vos réseaux sociaux.
            </p>
          </div>
          <Link to="/billing?utm_source=links&utm_medium=banner-bottom">
            <div className="ctaThird">Découvrir l'offre</div>
          </Link>
        </Col>
        <Col
          xl={12}
          ml={12}
          xs={24}
          sm={24}
          className="bannerRightSectionContainerNormal"
        >
          <div className="bannerIMG">
            <img src={image} width={imgWidth} alt="banner" />
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default BannerUpgrade;
